/**
 * Formata uma data no formato ISO 8601 (ex: 2025-09-30T00:00:00Z)
 * para o formato DD-MM-YYYY (ex: 30-09-2025)
 * @param {string} dateString - Data no formato ISO 8601
 * @returns {string} Data formatada no formato DD-MM-YYYY
 */
function formatDate(dateString) {
  if (!dateString) return ''
  try {
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  } catch (error) {
    console.error('Erro ao formatar data:', error)
    return ''
  }
}

export default formatDate
